import { Modal } from '@everlywell/leaves';
import React, { FC, useState, useEffect } from 'react';
import renderRichText, {
  ContentfulRichText,
} from 'utils/contentful/renderRichText';

import * as S from './styles';

type CallToAction = {
  text: string;
  url: string;
};

export type DisclaimerDataProps = {
  body: ContentfulRichText;
  callToAction: CallToAction;
  title: string;
};

interface Props extends DisclaimerDataProps {
  open: boolean;
  openHandler: (x: boolean) => void;
}

const PrePurchaseDisclaimer: FC<Props> = (props: Props) => {
  const { callToAction, body, title, open, openHandler } = props;
  const { text, url } = callToAction;

  const [isCurrentLocation, setisCurrentLocation] = useState(false);

  const label = text || 'Close';

  const modalHandler = (event: boolean) => openHandler && openHandler(event);

  const handleOnClick = () => modalHandler(false);

  /**
   * Mount Effect
   */
  useEffect(() => {
    if (window?.location) {
      setisCurrentLocation(window.location.pathname === url);
    }
  }, []);

  return (
    <Modal openHandler={modalHandler} open={open}>
      <S.Container>
        <S.Title>{title}</S.Title>
        <S.Body>{renderRichText(body)}</S.Body>
        <S.Footer>
          {url && url.length && !isCurrentLocation ? (
            <S.CTA appearance="primary" href={url}>
              {label}
            </S.CTA>
          ) : (
            <S.CTA appearance="primary" onClick={handleOnClick}>
              {label}
            </S.CTA>
          )}
        </S.Footer>
      </S.Container>
    </Modal>
  );
};

export default PrePurchaseDisclaimer;
